export default "__VITE_ASSET__H5qlAG2i__"